import { IWellnessPlanDetails } from "../../services/wellness-plan/wellness-plan.interface";

export const actionTypes = {
  SET_WELLNESS_PLAN_DETAILS: "SET_WELLNESS_PLAN_DETAILS",
};

const setWellnessPlanDetails = (payload: IWellnessPlanDetails | null) => ({
  type: actionTypes.SET_WELLNESS_PLAN_DETAILS,
  payload,
});


export default {
  setWellnessPlanDetails,
};
